import { Component } from '@angular/core';
import { ConfigService } from 'src/app/services/config/config.service';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-cookies',
  templateUrl: './cookies.component.html',
  styleUrls: ['./cookies.component.scss']
})
export class CookiesComponent {

  public websiteName: string;
  public emailAddress: string;
  public physicalAddress: string;
  public useRebrandedLayout: boolean;

  constructor(
    private configService: ConfigService,
    private featureFlagService: FeatureFlagsService
  ) { 
    this.websiteName = this.configService.getTextFromKey('cookie-page-website-name');
    this.emailAddress = this.configService.getTextFromKey('cookie-page-email-address');
    this.physicalAddress = this.configService.getTextFromKey('cookie-page-physical-address');
    this.useRebrandedLayout = this.featureFlagService.isEnabled('useRebrandedLayout');
  }
}
